import PageContainer from './page-container';

export default PageContainer;
